let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("WP2Js")]).then(() => parcelRequire('k9ngM'));